import { z } from "zod";

export const createIntentRequestSchema = z.object({
  source_type: z.string().min(1, "Source type is required"),
  source_key: z.string().min(1, "Source key is required"),
  source_raw: z.string().nullable().optional(),
  topic: z.string().min(1, "Topic is required"),
  category: z.string().nullable().optional(),
  buying_stage: z.string().min(1, "Buying stage is required"),
  channel: z.string().nullable().optional(),
  confidence: z.number().min(0).max(1, "Confidence must be between 0 and 1"),
  greeting: z.string().nullable().optional(),
  suggestion_chips: z.array(z.string()).nullable().optional(),
  entities: z.string().nullable().optional(),
  geo_relevance: z.string().nullable().optional(),
  model_used: z.string().nullable().optional(),
});
